import { AxiosError } from "axios";
import { t } from "i18next";

import { toast } from "react-toastify";

export const onError = (error: any) => {
  const axiosError = error as AxiosError<{ message?: string; error?: string }>;
  const data = axiosError?.response?.data;
  const message = data?.message ?? data?.error ?? error.message;

  toast(message ?? t("error.something-wrong"), { type: "error", theme: "dark" });
};
